<template>
  <div class="tag-list">
    <tag :tag="tag" :key="tag" v-for="tag in tags" />
  </div>
</template>

<style scoped>
  .tag-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    padding: 8px;
  }
</style>

<script>
import Tag from './Tag.vue';

export default {
  name: 'tag-list',
  props: {
    tags: {
      type: Array,
      required: true,
    },
  },
  components: {
    Tag,
  },
};
</script>
